/**
* 财务管理 开票申请
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>开票申请</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-date-picker
          v-model="formDate"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <!--      <el-form-item label="">-->
      <!--        <el-input size="small" v-model="formInline.order_code" placeholder="输入订单编号"></el-input>-->
      <!--      </el-form-item>-->
      <el-form-item label="">
        <el-input size="small" v-model="formInline.mobile" clearable placeholder="输入会员手机"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 510px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick"
                element-loading-text="拼命加载中" style="width: 60%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="apply_time" label="申请时间" width="150">
        </el-table-column>
        <el-table-column prop="mobile" label="会员手机号" width="150">
        </el-table-column>
        <el-table-column prop="apply_invoice_money" label="申请开票金额" width="150">
          <template slot-scope="scope">
            <div>￥{{scope.row.apply_invoice_money}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="invoice_type" label="发票类型" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.invoice_type=='182'">增值税专用发票</div>
            <div v-else-if="scope.row.invoice_type=='181'">增值税普通发票（电子发票）</div>
            <div v-else>增值税普通发票（纸质发票）</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="150">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="addInvoice(scope.row.id,scope.row.apply_invoice_money)"
                       style="width: 80px">开票
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <!-- 添加发票界面 -->
    <el-dialog :visible.sync="addInvoiceVisible" :before-close="handleClose"
               :close-on-click-modal="false" :close-on-press-escape="false" width="60%" top="7vh" center>
      <div class="billing_information">
        <p class="title f20 color333 fontWeight mb20">开票信息</p>
        <div class="flex_box f15 shipping_information mb20">
          <span class="color333 title mr12">收货人信息</span>
          <div class="flex_box" v-if="invoiceData.receive_name" style="width: calc(100% - 120px)">
            <p class="color666 mr12">
              {{invoiceData.receive_name}}，{{invoiceData.receive_phone}}，{{invoiceData.receive_addr}}</p>
            <span class="copy"
                  @click="copy(invoiceData.receive_name,invoiceData.receive_phone,invoiceData.receive_addr)"><img
              src="/static/img/copy.png" alt=""></span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">发票抬头</p>
            <span class="f14 color333">{{invoiceData.company_name}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">注册地址</p>
            <span class="f14 color333">{{invoiceData.reg_addr}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">发票类型</p>
            <span class="f14 color333">{{invoiceData.invoice_type=='180'?'增值税普通发票（纸质发票）':invoiceData.invoice_type=='181'?'增值税普通发票（电子发票）':'增值税专用发票'}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">注册电话</p>
            <span class="f14 color333">{{invoiceData.reg_tel}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">纳税识别号</p>
            <span class="f14 color333">{{invoiceData.identification}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">开户银行</p>
            <span class="f14 color333">{{invoiceData.bank}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">发票内容</p>
            <span class="f14 color333">{{invoiceData.invoice_content}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">开户银行账号</p>
            <span class="f14 color333">{{invoiceData.account}}</span>
          </div>
        </div>
        <div class="flex_box">
          <div class="flex_box billing_item">
            <p class="label f14 color666">收票人手机</p>
            <span class="f14 color333">{{invoiceData.receive_phone}}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="label f14 color666">电子邮箱</p>
            <span class="f14 color333">{{invoiceData.email}}</span>
          </div>
        </div>
      </div>
      <p class="title f20 color333 fontWeight mb20 mt50">发票信息</p>
      <el-table size="small" :data="orderTable" highlight-current-row v-loading="loading" border show-summary
                :summary-method="getSummaries"
                element-loading-text="拼命加载中" style="width: 100%;margin-bottom: 20px">
        <el-table-column
          type="index"
          label="序号"
          width="50">
        </el-table-column>
        <el-table-column prop="order_code" label="订单编号" min-width="150">
        </el-table-column>
        <el-table-column prop="invoice_balance" label="欠票金额" width="300">
          <template slot-scope="scope">
            <div>￥{{scope.row.invoice_balance}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="order_settle_money" label="订单金额" width="300">
          <template slot-scope="scope">
            <div>￥{{scope.row.order_settle_money}}</div>
          </template>
        </el-table-column>
      </el-table>
      <el-form label-width="120px" :model="invoiceForm" :rules="rules" ref="invoiceForm" class="delivery">
        <el-form-item label="发票号" prop="invoice_code">
          <el-input size="small" v-model="invoiceForm.invoice_code" auto-complete="off" placeholder="请输入发票号"
                    maxLength="40" clearable></el-input>
        </el-form-item>
        <el-form-item label="发票代号" prop="invoice_no">
          <el-input size="small" v-model="invoiceForm.invoice_no" auto-complete="off" placeholder="请输入发票代号"
                    maxLength="20" clearable></el-input>
        </el-form-item>
        <el-form-item label="开票金额" prop="invoice_money">
              <el-input size="small" v-model="invoiceForm.invoice_money" auto-complete="off" clearable disabled="disabled"
                        placeholder="请输入开票金额" maxLength="10"></el-input>
        </el-form-item>
        <el-form-item label="税率" prop="tax_rate" class="relative">
          <el-input size="small" v-model="invoiceForm.tax_rate" auto-complete="off" placeholder="请输入税率"></el-input>
          <span class="absolute percentage">%</span>
        </el-form-item>
        <el-form-item label="开票日期" prop="invoice_date">
          <el-date-picker
            v-model="invoiceForm.invoice_date"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发票类型" prop="invoice_type">
          <el-select v-model="invoiceForm.invoice_type" placeholder="请选择发票类型" clearable @change="changeType">
            <el-option label="增值税专用发票" value="182"></el-option>
            <el-option label="增值税普通发票（电子发票）" value="181"></el-option>
            <el-option label="增值税普通发票（纸质发票）" value="180"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电子发票上传" prop="pdf_url" v-if="invoiceForm.invoice_type==181">
          <div v-if = "invoiceForm.pdf_url">
            <div class="float-left" v-for="(video,index) in productPdfUrl" :key="index">
              <div class="video-list-box" @mouseenter="handleMouseEnter(video.isShowButton,index)"
                   @mouseleave="handleMouseLeave(video.isShowButton,index)">
                <div class="img-mask" v-show="video.isShowButton">
                  <div class="inline_block">
                    <el-upload
                      class="avatar-uploader"
                      action="#"
                      :show-file-list="false"
                      :http-request="uploadFile"
                      :before-upload="uploadDefaultUpload"
                    >
                    </el-upload>
                  </div>
                  <i class="el-icon-zoom-in" @click="lookInvoice"></i>
                  <i class="el-icon-delete" @click="delPdf(index)"></i>
                </div>
                <el-image class="inline_block video-default-img"
                          :src="video.img_url?video.img_url:defaultVideoImg">
                </el-image>
              </div>
            </div>
          </div>
          <div v-else>
            <el-upload list-type="picture-card" :http-request="uploadFile" ref="upload1"
                       v-loading.fullscreen.Tock="videoloading"
                       element-loading-text="拼命上传中" element-loading-spinner="el-icon-loading"
                       element-loading-background="rgba(0,0,0,0.8)"
                       class="avatar-uploader float-left avatar-uploader el-upload--text upload_btn" action="#" :show-file-list="false"
                       :file-list="productPdfFilesList"
                       :before-upload="beforeUploadPdf"
                       :on-success="handleSuccess"
                       :auto-upload="true"
                       :limit="1"
                       >
               <i class="el-icon-plus"></i>
            </el-upload>
          </div>
          <div class="note"><span>仅能上传pdf文件，文件大小限制为最大20M</span></div>
        </el-form-item>
        <el-form-item label="快递公司" prop="deliver_comp" v-if="invoiceForm.invoice_type!=181">
          <el-select v-model="invoiceForm.deliver_comp" filterable placeholder="请选择" clearable
                     @change="deliverChange(invoiceForm.deliver_comp)">
            <el-option
              v-for="item in popularDeliveryListData"
              :key="item.id"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号" prop="delivery_no" v-if="invoiceForm.invoice_type!=181">
          <el-input size="small" v-model.trim="invoiceForm.delivery_no" auto-complete="off" placeholder="请输入快递单号"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="电子发票上传" prop="pdf_url" v-if="invoiceForm.invoice_type==180 || invoiceForm.invoice_type==182">
          <div v-if = "invoiceForm.pdf_url">
            <div class="float-left" v-for="(video,index) in productPdfUrl" :key="index">
              <div class="video-list-box" @mouseenter="handleMouseEnter(video.isShowButton,index)"
                   @mouseleave="handleMouseLeave(video.isShowButton,index)">
                <div class="img-mask" v-show="video.isShowButton">
                  <div class="inline_block">
                    <el-upload
                      class="avatar-uploader"
                      action="#"
                      :show-file-list="false"
                      :http-request="uploadFile"
                      :before-upload="uploadDefaultUpload"
                    >
                    </el-upload>
                  </div>
                  <i class="el-icon-zoom-in" @click="lookInvoice"></i>
                  <i class="el-icon-delete" @click="delPdf(index)"></i>
                </div>
                <el-image class="inline_block video-default-img"
                          :src="video.img_url?video.img_url:defaultVideoImg">
                </el-image>
              </div>
            </div>
          </div>
          <div v-else>
            <el-upload list-type="picture-card" :http-request="uploadFile" ref="upload1"
                       v-loading.fullscreen.Tock="videoloading"
                       element-loading-text="拼命上传中" element-loading-spinner="el-icon-loading"
                       element-loading-background="rgba(0,0,0,0.8)"
                       class="avatar-uploader float-left avatar-uploader el-upload--text upload_btn" action="#" :show-file-list="false"
                       :file-list="productPdfFilesList"
                       :before-upload="beforeUploadPdf"
                       :on-success="handleSuccess"
                       :auto-upload="true"
                       :limit="1"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
          <div class="note"><span>仅能上传pdf文件，文件大小限制为最大20M</span></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" :disabled="!isCanSubmit"
                   @click="submitInvoiceForm('invoiceForm')">保 存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    invoiceApplyList, financeDetail,
    popularDeliveryList, addFinanceInvoice
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {timestampToTime, timestampToDate, uploadFile} from "../../utils/util";
  import {param, uploadVideo, uploadImgTmp, uploadPdf, getToken} from '../../api/commonMG'

  export default {
    data: () => {
      var validateRate = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入税率'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else if (Number(value) > 100) {
          return callback(new Error('税率不能大于100'));
        } else {
          return callback();
        }
      };
      var validateSalePrice = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入开票金额'));
        } else if (!(/(^0\.[1-9]\d?$)|(^0\.\d[1-9]?$)|(^[1-9]\d{0,7}(\.\d{0,2})?$)/.test(value))) {
          return callback(new Error('请输入正确的开票金额'));
        } else {
          return callback();
        }
      };

      return {
        id: '',
        loading: false, //是显示加载
        logisticsVisible: false, //控制页面显示与隐藏
        formDate: '',
        videoloading: false,
        hideUpload: false,
        showBtnImg:true,
        noneBtnImg:false,
        formInline: {
          page: 1,
          rows: 10,
          order_code: '',
          mobile: '',
          begin_time: "",
          end_time: ""
        },
        addInvoiceVisible: false,
        invoiceData: {},
        popularDeliveryListData: [],
        invoiceDate: '',
        invoiceForm: {
          invoice_code: '',
          invoice_no: '',
          invoice_money: '',
          tax_rate: '',
          invoice_date: '',
          invoice_type: '',
          delivery_no: '',
          deliver_comp: '',
          deliver_comp_id: '',
          pdf_url: '',
          order_settle_money: '',
        },
        imgUrl: '',
        form: {
          image: ''
        },
        PdfDefaultImgIndex: 0,
        defaultVideoImg: '/static/img/pdf.png',
        productPdfUrl: [],
        productPdfFilesList: [],
        // rules表单验证
        rules: {
          invoice_code: [
            {required: true, message: '请输入发票号', trigger: 'blur'}
          ],
          invoice_no: [{required: true, message: '请输入发票代号', trigger: 'blur'}],
          invoice_money: [{required: true, validator: validateSalePrice, trigger: 'blur'}],
          tax_rate: [{required: true, validator: validateRate, trigger: 'blur'}],
          invoice_date: [{required: true, message: '请选择开票日期', trigger: 'change'}],
          invoice_type: [{required: true, message: '请选择发票类型', trigger: 'change'}],
          // delivery_no: [{required: true, message: '请填写快递单号', trigger: 'blur'}],
          // deliver_comp: [{required: true, message: '请选择物流公司', trigger: 'change'}],
          // pdf_url: [{required: true, message: '请选择发票PDF文件', trigger: 'blur'}]
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        tableData: {},
        orderTable: [],
        apply_invoice_money: '',
        isCanSubmit: true,
      }
    },
    // 注册组件
    components: {
      Pagination
    },

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      lookInvoice() {
        window.open(this.invoiceForm.pdf_url)
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        invoiceApplyList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        if (this.formDate) {
          this.formInline.begin_time = timestampToDate(this.formDate[0])
          this.formInline.end_time = timestampToDate(this.formDate[1])
        } else {
          this.formInline.begin_time = ''
          this.formInline.end_time = ''
        }
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.mobile == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
      //显示物流界面
      logistics: function (delivery_no) {
        this.logisticsVisible = true
        invoiceDeliveryLog(delivery_no)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.tableData = res.content || '';
            }
          })
          .catch(err => {
            this.loading = false
            // this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 点击复制
      copy(name, phone, addr) {
        let url = name + ',' + phone + ',' + addr;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        oInput.remove()
      },
      //添加发票
      addInvoice(id, apply_invoice_money) {
        this.addInvoiceVisible = true;
        this.apply_invoice_money = apply_invoice_money
        this.invoiceForm = {
          invoice_code: '',
          invoice_no: '',
          invoice_money: '',
          tax_rate: '',
          invoice_date: '',
          invoice_type: '',
          delivery_no: '',
          deliver_comp: '',
          deliver_comp_id: '',
          pdf_url: '',
          order_settle_money: '',
        };
        this.form.image = '';
        this.imgUrl = '';
        this.id = id;
        financeDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.invoiceData = res.content.invoice_apply_info || '';
              this.orderTable = res.content.invoice_item_list || '';
              this.invoiceForm.invoice_money = res.content.total_invoice_apply_money
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
        let data = {
          page: 0,
          rows: 10,
          name: ""
        }
        popularDeliveryList(data)
          .then(res => {
            if (res.success) {
              this.popularDeliveryListData = res.content;
            }
          })
          .catch(err => {
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      checkDate(date) {
        if (/^(\d{4})-(\d{2})-(\d{2})$/.test(date)) {
          return true
        } else {
          return false
        }
      },
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总价';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else {
            sums[index] = '-';
          }
        });

        return sums;
      },
      //添加发票
      submitInvoiceForm(formName) {
        if (this.invoiceForm.invoice_money > this.apply_invoice_money) {
          this.$message.error('开票金额不能大于申请开票金额!');
          return
        }
        this.invoiceForm.id = this.id;
        this.invoiceForm.delivery_no = this.invoiceForm.delivery_no
        if (!this.checkDate(this.invoiceForm.invoice_date)) {
          this.invoiceForm.invoice_date = timestampToDate(this.invoiceForm.invoice_date)
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false
            addFinanceInvoice(this.invoiceForm)
              .then(res => {
                this.isCanSubmit = true;
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '添加成功!'
                  });
                  this.getdata(this.formInline)
                  this.addInvoiceVisible = false;
                }
              })
              .catch(err => {
                this.isCanSubmit = true;
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            return false;
          }
        });
      },
      deliverChange(name) {
        this.popularDeliveryListData.forEach((item) => {
          if (item.name == name) {
            this.invoiceForm.deliver_comp_id = item.id
          }
        })
      },
      changeType() {
        this.$nextTick(() => {
          this.$refs["invoiceForm"].clearValidate(['pdf_url', 'deliver_comp', 'delivery_no']);
        });
      },
      //关闭弹窗时的操作
      handleClose() {
        this.$refs["invoiceForm"].resetFields();
        this.addInvoiceVisible = false;
        this.productPdfUrl = [];
      },
      uploadFile(file) {
      },
      handleMouseLeave(isShowButton, i) {
        this.productPdfUrl[i].isShowButton = false;
      },
      uploadDefaultUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png" || file.type == "image/jpg";
        const isLt1M = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.$message.warning("上传图片仅支持jpg、jpeg、png格式!");
          return false
        }
        if (!isLt1M) {
          this.$message.warning("上传图片大小不能超过 1MB!");
          return false
        }
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          let width = '';
          let height = '';
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function () {
            imgWidth = img.width
            imgHight = img.height
            let valid = img.width == width && img.height == height;
            valid ? resolve() : reject();
          }
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          // const fileData = new FormData();
          // fileData.append("file", file);
          // //upload为上传的接口
          // uploadImgTmp(fileData).then(res => {
          //   this.productPdfUrl[this.videoDefaultImgIndex].img_url = res.content
          // }).catch(err => {
          //   this.loading = false
          //   this.$message.error('上传失败，请稍后再试！')
          // })
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                this.productPdfUrl[this.videoDefaultImgIndex].img_url = res.data.content.file.fileUrl
              })
            }
          });
          //阻止传到本地浏览器
          return false;
        }, () => {
          this.$message({
            type: 'warning',
            message: '上传图片的尺寸应为500*500,当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
            duration: 2000
          });
          return Promise.reject()
          return false;//必须加上return false; 才能阻止
        })
        return isSize;
      },
      delPdf(i) {
        this.productPdfUrl.forEach((item) => {
          this.productPdfUrl.splice(i, 1)
        })
        this.invoiceForm.pdf_url = ''
      },
      handleMouseEnter(isShowButton, i) {
        this.videoDefaultImgIndex = i;
        this.productPdfUrl[i].isShowButton = true;
      },
      beforeUploadPdf(file) {
        const isLt20M = file.size / 1024 / 1024 < 20;
        if (file.type.indexOf('pdf') == -1) {
          this.$message.error('请上传正确的PDF格式');
          return false;
        }
        if (!isLt20M) {
          this.$message.error('上传pdf大小不能超过20MB哦!');
          return false;
        }
        let that = this
        // const fileData = new FormData();
        // fileData.append("file", file);
        // //uploadPdf为上传的接口
        // this.videoloading = true;
        // uploadPdf(fileData).then(res => {
        //   let data = {
        //     img_id: "",
        //     pdf_url: res.content,
        //     img_url: '',
        //     isShowButton: false
        //   }
        //   this.videoloading = false;
        //   that.invoiceForm.pdf_url = res.content;
        //   this.productPdfUrl.push(data)
        // }).catch(err => {
        //   this.videoloading = false
        //   this.$message.error('上传失败，请稍后再试！')
        // })
        this.videoloading = true;
        getToken().then(res => {
          if(res) {
            let result = uploadFile(res,file);
            result.then(res => {
                let data = {
                  img_id: "",
                  pdf_url: res.data.content.file.fileUrl,
                  img_url: '',
                  isShowButton: false
                }
                this.videoloading = false;
                that.invoiceForm.pdf_url = res.data.content.file.fileUrl;
                this.productPdfUrl.push(data)
            })
          }
        });
      },
      handleSuccess(response, file, fileList) {
         this.upload_btn = true;
      },
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  .color333 {
    color: #333333;
  }

  .color666 {
    color: #666666;
  }

  .userRole {
    width: 100%;
  }

  .delivery {
    margin-bottom: 10px;
  }

  .delivery_text {
    margin-left: 20px;
    margin-right: 5px;
  }

  .mr12 {
    margin-right: 12px;
  }

  .mt50 {
    margin-top: 50px;
  }

  .mb10 {
    margin-bottom: 10px;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  .f15 {
    font-size: 15px;
  }

  .f14 {
    font-size: 14px;
  }

  .f20 {
    font-size: 20px;
  }

  .fontWeight {
    font-weight: 600;
  }

  .color333 {
    color: #333333;
  }

  .color666 {
    color: #666666;
  }

  .flex_box {
    display: flex;
  }

  /deep/ .delivery .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 220px;
  }

  /deep/ .delivery .el-input--small {
    width: 220px;
  }

  .copy {
    width: 20px;
    height: 20px;
  }

  .copy img {
    width: 20px;
    height: 20px;
  }

  .label {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #F5F7FA;
    padding-left: 12px;
  }

  .billing_item {
    border-bottom: 1px solid #EBEEF5;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 375px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  .relative {
    position: relative;
  }

  .absolute {
    position: absolute;
  }

  .percentage {
    left: 200px;
  }

  /deep/ .delivery .el-form-item {
    margin-left: 25%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar {
    width: 146px;
    height: 146px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .avatar-uploader {
    height: 146px;
  }

  .video-default-img {
    border-radius: 6px;
  }

  /deep/ .el-image {
    width: 146px;
  }

  .video-list-box {
    width: 146px;
    height: 146px;
    margin-right: 10px;
    margin-bottom: 20px;
    border-radius: 6px;
    position: relative
  }

  .img-mask {
    width: 146px;
    height: 146px;
    line-height: 146px;
    background: #000;
    opacity: 0.6;
    position: absolute;
    z-index: 99;
    text-align: center;
    border-radius: 6px;
  }

  .img-mask i {
    color: #fff;
    font-size: 20px;
    margin-left: 20px;
    margin-right: 20px;
    cursor: pointer;
  }

  .hide_box /deep/ .el-upload--picture-card {
      display: none;
  }

  .note {
    margin-top: 50px;
  }

  .note span {
    margin-left: 10px;
    font-size: 12px;
    color: #D9001B;
    line-height: 20px;
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/views/finance/InvoicingApplication.vue